import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Card, Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4, 5),
    alignItems: "flex-start"
  }
}));

const AddResource = ({ onAdd }) => {
  const classes = useStyles();
  const [title, setTitle] = React.useState("");
  const [editing, setEditing] = React.useState(false);
  const { t } = useTranslation();

  return (
    <Card className={classes.card}>
      {!editing ? (
        <Button
          color="primary"
          onClick={() => {
            setTitle("");
            setEditing(true);
          }}
        >
          {t("learningCenterResources.addSection")}
        </Button>
      ) : (
        <TextField
          value={title}
          onChange={ev => {
            setTitle(ev.target.value);
          }}
          onKeyUp={ev => {
            if (ev.key === "Enter") {
              setEditing(false);
              onAdd(title);
            }
          }}
          fullWidth
          variant="filled"
          InputProps={{
            placeholder: t("learningCenterResources.sectionNamePlaceholder")
          }}
          hiddenLabel
        />
      )}
    </Card>
  );
};

export default AddResource;
